import { useState } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { Kanban, ListTodo } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { KanbanPage } from '@/pages/admin/Kanban';
import { TasksListPage } from '@/pages/admin/TasksList';
import { useSearchParams } from 'react-router-dom';

type TasksViewMode = 'kanban' | 'list';

export function TasksWorkspacePage() {
  const { isTeamLeader, isAgent } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const initialView = searchParams.get('view') === 'list' ? 'list' : 'kanban';
  const [viewMode, setViewMode] = useState<TasksViewMode>(initialView);

  const handleViewChange = (value: string) => {
    const next = value === 'list' ? 'list' : 'kanban';
    setViewMode(next);
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set('view', next);
    setSearchParams(nextParams, { replace: true });
  };

  // Admin and other roles keep the original Kanban page behavior.
  if (!isTeamLeader && !isAgent) {
    return <KanbanPage />;
  }

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <Tabs value={viewMode} onValueChange={handleViewChange}>
          <TabsList>
            <TabsTrigger value="kanban" className="gap-2">
              <Kanban className="h-4 w-4" />
              Kanban
            </TabsTrigger>
            <TabsTrigger value="list" className="gap-2">
              <ListTodo className="h-4 w-4" />
              List
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </div>

      {viewMode === 'kanban' ? <KanbanPage /> : <TasksListPage />}
    </div>
  );
}
